import { hasCapability, type User } from "../base";

export const lineItemPrice = {
  read: (user: User) => hasCapability(user, "lineItemPrice.read"),
  create: (user: User) => hasCapability(user, "lineItemPrice.create"),
  update: (user: User) => hasCapability(user, "lineItemPrice.update"),
};
